// Copyright 2020 Sorama B.V.

import { PLATFORM } from "aurelia-framework";
import {
    CanvasMediaObjectLinkDTO,
    LinkedMediaObjectType,
    TwoDimensionalLinkedMediaObjectDTO,
} from "datatypes/SoramaWebApi";
import { ICanvasMediaObjectLinkRepository } from "repositories/CanvasMediaObjectLinkRepository";
import { BoundingBox, IComposableParent } from "./../ComposableCanvas";
import { IComposableMediaObjectAction } from "./ComposableMediaObject";
import { ComposableTwoDimensionalMediaObject } from "./ComposableTwoDimensionalMediaObject";

export class ComposableImageMediaObject extends ComposableTwoDimensionalMediaObject {
    public readonly template: string = PLATFORM.moduleName("controls/composable-canvas/templates/ImageTemplate.html");
    public readonly additionalActions: IComposableMediaObjectAction[] = [];

    public get mediaObjectType(): LinkedMediaObjectType {
        return LinkedMediaObjectType.Image;
    }

    protected source: string;

    constructor(
        linkRepository: ICanvasMediaObjectLinkRepository,
        parent: IComposableParent,
        link: CanvasMediaObjectLinkDTO,
        initialSize: BoundingBox,
        source: string | Promise<string>,
        mediaObject: TwoDimensionalLinkedMediaObjectDTO
    ) {
        // Using TwoDimensionalLinkedMediaObjectDTO here instead of ImageDTO so the snapshot composable media object can extend from this
        super(linkRepository, parent, link, initialSize, mediaObject);

        if (!source) {
            return;
        }

        if (typeof source == "string") {
            this.source = source;
        } else {
            this.busy = true;
            (source as Promise<string>)
                .then((x) => (this.source = x))
                .catch((x) => {
                    // Broken image, UI will show a placeholder instead
                })
                .then(() => {
                    this.busy = false;
                });
        }
    }
}
